var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.useShape1)?_c('package-print-shape1'):_c('package-print-shape2')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }